const BASE_PATH = '/employers/employer_renewals'

export enum EmployerRenewalsRoute {
  INTRO = BASE_PATH,
  WHAT_TO_EXPECT = `${BASE_PATH}/what-to-expect`,
  EMPLOYEES_HEADCOUNT = `${BASE_PATH}/employees/headcount`,
  EMPLOYEES_CENSUS = `${BASE_PATH}/employees/info`,
  EMPLOYEES_ELIGIBILITY = `${BASE_PATH}/employees/eligibility`,
  ALLOWANCES_REVIEW = `${BASE_PATH}/allowances/review`,
  ALLOWANCES_QME = `${BASE_PATH}/allowances/qme`,
  ALLOWANCES_DEPENDENTS_COVERAGE = `${BASE_PATH}/allowances/dependents-coverage`,
  ALLOWANCES_CONFIRM = `${BASE_PATH}/allowances/confirm`,
  ALLOWANCES_COMPLETE = `${BASE_PATH}/allowances/complete`,
}

export const REVIEW_ACCEPTED_ROUTE = '/allowances/review-accepted'
